const UNIT_ALIASES: Record<string, string> = {
  // NFKC+lowercase後のキーで定義
  ヘクタール: "ha", // ㌶, ﾍｸﾀｰﾙ, ヘクタール → NFKC → ヘクタール
  キロメートル: "km",
  メートル: "m",
  キログラム: "kg",
  トン: "t",
  リットル: "l",
  キロリットル: "kl",
  平米: "m2",
  平方メートル: "m2",
  平方メーター: "m2",
  平方m: "m2",
  立米: "m3",
  立方メートル: "m3",
  立方メーター: "m3",
  立方m: "m3",
};

const UNIT_PRECISION: Record<string, number> = {
  km: 0.1,
  ha: 0.001,
  m2: 0.1, // ｍ2, ㎡, m² → NFKC+lowercase → m2
  m: 0.1,
  箇所: 0.1,
  h: 0.1,
  本: 0.1,
  kl: 0.001, // KL → lowercase → kl
  組: 0.1,
  株: 0.1,
  日: 0.1,
  "台・日": 0.1,
  "台・回": 0.1,
  袋: 0.1,
  回: 0.1,
  枚: 0.1,
  個: 0.1,
  "条・m": 0.1,
  基: 0.1,
  日規制: 0.1,
  "0.5日規制": 0.1,
  m3: 0.001, // ｍ3, ㎥, m³ → NFKC+lowercase → m3
  kg: 0.1,
  人: 0.1,
  式: 0.1,
  t: 0.001,
  台: 0.1,
  l: 0.1, // L → lowercase → l
  "人・日": 0.1,
  セット: 0.1,
  "人・時間": 0.1,
  箱: 0.1,
  缶: 0.1,
  ケース: 0.1,
  ポット: 0.1,
};

const normalizeUnit = (unit: string): string => {
  const nfkc = unit.normalize("NFKC").toLowerCase();
  return UNIT_ALIASES[nfkc] ?? nfkc;
};

export const getPrecision = (unit: string | null | undefined): number => {
  if (!unit) return 0.1;
  return UNIT_PRECISION[normalizeUnit(unit)] ?? 0.1;
};

export const formatValue = (value: number, precision: number): string => {
  const rounded = Math.round(value / precision) * precision;
  const decimals = precision <= 0.001 ? 3 : 1;
  return rounded.toLocaleString("ja-JP", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};
